import { Token } from './token';

export class TokenHelper {
  setToken(tokenName: string, data: Token) {
    localStorage.setItem(tokenName, JSON.stringify(data));
  }

  getToken(tokenName: string): Token {
    if (localStorage.getItem(tokenName) === null) {
      return null
    }
    return new Token(JSON.parse(localStorage.getItem(tokenName)));
  }

  removeToken(tokenName: string) {
    if (this.getToken(tokenName) != null) {
      localStorage.removeItem(tokenName);
    }
  }

  isTokenExpired(token: Token) {
    if (token === null) {
      return true
    }
    var d = token.expiresAt.getTime();
    var now = Date.now();
    return d < now;
  }

  //get expiration date in the moment of token response
  getExpiresAt(expiresIn: number): Date {
    var d = new Date();
    d = new Date(d.getTime() + expiresIn * 1000);
    return d;
  }
}
